import { render, staticRenderFns } from "./RequestBuilderPart.vue?vue&type=template&id=d2118816&scoped=true"
import script from "./RequestBuilderPart.vue?vue&type=script&lang=js"
export * from "./RequestBuilderPart.vue?vue&type=script&lang=js"
import style0 from "./RequestBuilderPart.vue?vue&type=style&index=0&id=d2118816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2118816",
  null
  
)

export default component.exports